import React from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import BaseModal, { modalStyles, HoverButton } from './BaseModal';
import ModalStickyFooter from '../ui/ModalStickyFooter';
import { colors, typography } from '../../styles/theme';

interface RestartModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function RestartModal({ visible, onClose, onConfirm }: RestartModalProps) {
  return (
    <BaseModal
      visible={visible}
      onClose={onClose}
      animationType="fade"
      isFullScreenOnMobile={false}
      header={(
        <>
          <Text style={modalStyles.headerText}>Restart Puzzle?</Text>
          <Text style={modalStyles.subtitleText}>Your progress will be lost.</Text>
        </>
      )}
      footer={(
        <ModalStickyFooter style={modalStyles.buttonContainer}>
          <HoverButton 
            style={[modalStyles.primaryButton]} 
            hoverStyle={modalStyles.primaryButtonHover}
            textStyle={modalStyles.primaryButtonText}
            onPress={onConfirm}
          >
            Restart
          </HoverButton>
          <HoverButton 
            style={modalStyles.clearButton} 
            textStyle={modalStyles.clearButtonText}
            onPress={onClose}
          >
            Cancel
          </HoverButton>
        </ModalStickyFooter>
      )}
    >
    </BaseModal>
  );
}

